"use client";
import { usePublicT } from "../public-locale";


import { ThemeProvider } from "./contexts/ThemeContext";
import { MarketingAppLinkProvider } from "./contexts/MarketingAppLinkContext";
import { CheckoutProvider } from "./components/CheckoutButton";

export function MarketingProviders({ signInHref, children }: { signInHref: string; children: React.ReactNode }) {
  const t = usePublicT();
  return <MarketingAppLinkProvider signInHref={signInHref}><ThemeProvider><CheckoutProvider>{t(children)}</CheckoutProvider></ThemeProvider></MarketingAppLinkProvider>;
}
